import React from "react";
import PropTypes from 'prop-types';

export class DialogHeader extends React.PureComponent {
    render() {
        let { children } = this.props;

        return (
            <div className={'dialog-header'}>
                {children}
            </div>
        )
    }
}

DialogHeader.propTypes = {
    children: PropTypes.node.isRequired,
};

export default class Dialog extends React.PureComponent {
    clickHandler = (e) => {
        let { onClose } = this.props;

        e.stopPropagation();

        onClose();
    };
    render() {
        let { children, isVisible, className } = this.props;

        if (!isVisible) {
            return false;
        }

        return (
            <div className={'dialog-container' + (className ? ` ${className}` : '')} onClick={this.clickHandler}>
                <div className={'dialog'} onClick={(e) => {
                    e.stopPropagation();
                }}>
                    {children}
                </div>
            </div>
        );
    }
}

Dialog.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    onClose: PropTypes.func.isRequired,
    isVisible: PropTypes.bool.isRequired,
};

